import { pageIndex, pageSize } from "../../constants/page";
import sDocumentAxios from "./statistic-documents.service";
import axios from "./config.service";

export interface Department {
  id: number;
  parentId: number;
  areaCode: string;
  code: string;
  name: string;
  viagsDepartmentChild: Department[];
}

export class DepartmentService {
  static async getDepartmentList(departmentCode?: string) {
    try {
      const res = await axios.get<{ data: Department[]; statusCode: number }>("/viagsemployee/get-list-department", {
        params: { departmentCode },
      });
      if (res.data.statusCode !== 200) return;
      return res.data.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async getDepartmentListV5(departmentCode?: string, departmentId?: number) {
    const { data } = await sDocumentAxios.get("/viagsemployee/get-list-department", {
      params: { departmentId, departmentCode, pageIndex, pageSize },
    });
    return data.data;
  }

  static async getDepartmentListVById(departmentIds: string[] = []) {
    const { data } = await sDocumentAxios.post("/viagsemployee/get-list-department-by-ids", departmentIds);
    return data.data;
  }
}
